import { breadcrumbSlot } from "@redotech/arbiter/breadcrumb";
import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";

const attributeDefinitionsBreadcrumb = breadcrumbSlot();

export const productSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Attribute Definitions", {
          context:
            "merchant settings page heading for product attribute definitions",
        });
      },
      permission: settingsPagePermission("products/attributes"),
    },
    path: "attributes",
    children: [
      {
        index: true,
        lazy: async () => {
          const { AttributeDefinitionsLandingPage } =
            await import("../../../../setting/attribute-definitions");
          return { Component: AttributeDefinitionsLandingPage };
        },
      },
      {
        handle: { breadcrumb: attributeDefinitionsBreadcrumb },
        path: ":ownerType",
        async lazy() {
          const { AttributeDefinitionsPage } =
            await import("../../../../setting/attribute-definitions");
          return {
            element: (
              <AttributeDefinitionsPage
                breadcrumb={attributeDefinitionsBreadcrumb}
              />
            ),
          };
        },
      },
    ],
  },
  {
    handle: {
      get breadcrumb() {
        return t("Products", {
          context: "merchant settings label for products",
        });
      },
      permission: settingsPagePermission("products/products"),
    },
    path: "products",
    async lazy() {
      const { ProductPage } =
        await import("../../../../setting/product/product");
      return { Component: ProductPage };
    },
  },
];
